module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-cyrillic363.077ed71.woff2";